
export default {
  getApps: '/api/campaign/getApps',
  getLocations: '/api/campaign/getLocations',
  getCampaignDetails: '/api/campaign/getCampaignDetails'
}



// WEBPACK FOOTER //
// ./src/urls/newCampaignUrls.js